import WelcomeCallInformation from './WelcomeCallInformation'

export default WelcomeCallInformation
